const keys = {
	species: {
		/*
		LATEST AND FINAL LIST ACCORDING TO ISSUE #10  
Crassostrea virginica //American oyster
Mercenaria mercenaria  //Hard Clams
Argopectin irradians //Bay Scallops
Mya arenaria //Softshell Clam
Ostrea edulis //European Oyster
Mercenaria campechiensis //Southern Hardshell Clam
Geukensia demissa //Ribbed Mussel
Spisula solidissima //Surf Clams
Placopectin magellicanus //Sea Scallops
*/

		American_Oyster: {name: 'American Oyster', sciName: 'Crassostrea virginica'},
		Hard_Clams: {name: 'Hard Clams', sciName: 'Mercenaria mercenaria'},
		Bay_Scallops: {name: 'Bay Scallops', sciName: 'Argopecten irradians'},
		Softshell_Clam: {name: 'Softshell Clam', sciName: 'Mya arenaria'},
		European_Oyster: {name: 'European Oyster', sciName: 'Ostrea edulis'},
		Southern_Quahog: {name: 'Southern Quahog', sciName: 'Mercenaria campechiensis'},
		Ribbed_Mussel: {name: 'Ribbed Mussel', sciName: 'Geukensia demissa'},
		Surf_Clams: {name: 'Surf Clams', sciName: 'Spisula solidissima'},
		Sea_Scallops: {name: 'Sea Scallops', sciName: 'Placopectin magillanicus'},



		//Blood_Ark: {name: 'Blood Ark', sciName: 'Anadara ovalis'},
		//Sunray_Venus_Clams: {name: 'Sunray Venus Clams', sciName: 'Macrocallista nimbosa'},
	},
	///Just use the keys for now...
	availableCurrentData: [
		{
			speciesKey:'American_Oyster',
			pathogenKeys: ['Perkinsus', 'MSX', 'SSO']
		}
	],
	availableMusselWatchData: [
		{
			speciesKey:'American_Oyster',
			pathogenKeys: ['Perkinsus', 'MSX']
		}
	],


	diseases: {
		Dermo: {name: 'Dermo'},
	},
	pathogens: {

		
		/*
Perkinsus
MSX
SSO
DN
Bonamia exitiosa
ROD
QPX
Coccidians
Trematode
		*/
		//Clam_Perkinsus: {name: 'Clam Perkinsus'},//  (Absorbed into the general Perkinsus)
		Perkinsus: {name: 'Perkinsus'},
		MSX: {name: 'MSX'},
		SSO: {name: 'SSO'},
		//Dermo: {name: 'Dermo'},//  (Absorbed into the general Perkinsus)
		DN: {name: 'Disseminated neoplasia'},
		Bonamia: {name: 'Bonamia exitiosa'},
		ROD_JOD: {name: 'ROD JOD'},
		QPX: {name: 'QPX'},
		Coccidians: {name: 'Coccidians'}, //NEW
		Digenean_trematodes: {name: 'Digenean trematodes'},

		/*
		Chlamydial_Ricketsial: {name: 'Chlamydial Ricketsial'},
		Gonadal_neoplasia: {name: 'Gonadal neoplasia'},
		Hemocytic_neoplasia: {name: 'Hemocytic neoplasia'},
		Hinge_lingament: {name: 'Hinge lingament'},
		Mussel_egg: {name: 'Mussel egg'},
		Oyster_Herpes: {name: 'Oyster Herpes'},
		Pea_crabs: {name: 'Pea_crabs'},
		Vibrosis: {name: 'Vibrosis'},
		Xenomas: {name: 'Xenomas'},
		*/
	},
	diseaseData: {
		American_Oyster: ['Dermo', 'MSX']
	},
	speciesPathogenMatrix: {
		
		American_Oyster:[ 'Bonamia','Chlamydial_Ricketsial',
			//'Dermo',
			'Perkinsus',
			'Digenean_trematodes','Gonadal_neoplasia','Hemocytic_neoplasia',
			'MSX','Oyster_Herpes','ROD_JOD','SSO','Vibrosis','Xenomas'],
		Bay_Scallops:[ 'Chlamydial_Ricketsial'],
		Blue_Mussel:[ 'Digenean_trematodes','Hemocytic_neoplasia','Mussel_egg'],
		European_Oyster:[ 'Bonamia'],
		Hard_Clams:[ 'Gonadal_neoplasia','QPX'],
		Softshell_Clam:[ 'Chlamydial_Ricketsial',
		'Perkinsus',
		//'Clam_Perkinsus',
		'Gonadal_neoplasia'],
		Sunray_Venus_Clams:[ 'Hinge_ligament'],
		Ribbed_Mussel:[ 'Perkinsus']
	}
};
console.warn('(TODO: Future Update)Update keys.diseaseData or make it pull data from the API.');
export default keys;